import {ProductEnum, timeRangeOptions} from "@/utils/options";

export default () => [
  {
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
      return [
        {
          name: 'gj-input',
          prop: 'name',
          propsData: {
            placeholder: '请输入视图名称',
            style: {
              width: '256px'
            }
          }
        }
      ]
    },
    validator: [
      {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
  },
  {
    label: '状态',
    prop: 'state',
    components: [
      {
        name: 'gj-select',
        prop: 'state',
        propsData: {
          placeholder: '产品状态',
          options: ProductEnum.statusOption,
        }
      }
    ],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ProductEnum.status.ACTIVE
  },
  {
    label: '品类',
    prop: 'categoryId',
    components: [
      {
        name: 'gj-category-select',
        prop: 'categoryId',
        propsData: {
          multiple: true
        }
      }
    ],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
  },
  {
    label: '品牌',
    prop: 'brandId',
    components: [
      {
        name: 'gj-brand-select',
        prop: 'brandId',
        propsData: {
          active: true
        }
      }
    ],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: null
  },
  {
    label: '创建人',
    prop: 'createUserId',
    components: [
      {
        name: 'gj-creator-select',
        prop: 'createUserId',
        propsData: {
          active: true
        }
      }
    ],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: null
  },
  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [
      {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
          placeholder: '时间范围',
          options: timeRangeOptions
        }
      }
    ]
  }
];
